module.exports = __webpack_public_path__ + "static/media/Imagen-1.2c17212c.png";